import faker from "@faker-js/faker";
import {
  createContext,
  useState,
  Dispatch,
  ReactElement,
  useEffect,
} from "react";
import { Creator } from "@src/core/models/creator";
import { mockCreator } from "@src/core/mocks/models/creator";
import profileImage from "@src/presentation/assets/images/sample-drop/trudy-lines.png";

export interface CreatorContextProps {
  creator?: Creator;
}

interface CreatorProviderProps {
  children: ReactElement;
}

export const CreatorContext = createContext<CreatorContextProps>({});

export const CreatorProvider = ({
  children,
}: CreatorProviderProps): JSX.Element => {
  const [creator, setCreator] = useState<Creator>();

  useEffect(() => findCreator(setCreator), []);

  return (
    <CreatorContext.Provider value={{ creator }}>
      {children}
    </CreatorContext.Provider>
  );
};

const findCreator = (setCreator: Dispatch<Creator>): void => {
  // TODO: uncomment the following block as soon as we have a creator's endpoint
  // HttpClient.get<Creator>(endpoints.creatorFind(), (response) => {
  //   setCreator(response);
  // });
  setCreator(
    mockCreator({
      bio: "World-reknowned tattoo artist based in NYC at the legendary Bang Bang Tattoo Studio + founder of the nonprofit BottleNo30 to mobilize a global movement against single-use plastics.",
      hashId: faker.datatype.uuid(),
      id: faker.datatype.uuid(),
      name: "Trudy Lines",
      profileImageUrl: profileImage,
      role: "Artist",
      socialMedia: [
        { type: "facebook", url: faker.internet.url() },
        { type: "instagram", url: faker.internet.url() },
        { type: "pinterest", url: faker.internet.url() },
        { type: "twitter", url: faker.internet.url() },
        { type: "website", url: faker.internet.url() },
      ],
    })
  );
};
